module.exports = __webpack_public_path__ + "img/logo.aee1b249.png";